<script>
import appConfig from '@src/app.config.json'
import Axios from '@plugin/axios'
import Layout from '@layouts/main.vue'
import PlainCard from '@components/ui/cards/plain-card.vue'
import Skeleton from '@components/_base-skeleton.vue'
import Breadcrumb from '@components/ui/basic-breadcrumb.vue'
import queryString from 'query-string'

export default {
  page() {
    return {
      title: this.pageTitle,
      meta: this.pageMeta,
    }
  },
  components: {
    Layout,
    PlainCard,
    Skeleton,
    Breadcrumb,
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      const penghubung =
        'and,for,with,of,dan,serta,atau,tetapi,melainkan,padahal,sedangkan,yang,agar,supaya,biar,jika,kalau,jikalau,asalkan,bila,manakala,sejak,semenjak,sedari,sewaktu,tatkala,ketika,sementara,begitu,seraya,selagi,selama,serta,sambil,demi,setelah,sesudah,sebelumsehabis,selesai,seusai,hingga,sampai,andaikan,seandainya,umpamanya,sekiranya,biarpun,walaupun,sekalipun,sungguhpun,kendatipun,seakan-akan,seolah-olah,sebagaimana,seperti,sebagai,laksana,ibarat,daripada,alih-alih,karena,sampainya,makanya,dengan,tanpa,bahwa,as,ke'
      const str = value
        .trim()
        .replace(/ {1,}/g, ' ')
        .toLowerCase()
        .split(' ')
        .map((word) => {
          if (penghubung.split(',').includes(word)) {
            return word[0].toLowerCase() + word.slice(1)
          } else if (word[0] === '(') {
            return '(' + word.charAt(1).toUpperCase() + word.substring(2)
          }
          return word[0].toUpperCase() + word.slice(1)
        })
        .join(' ')
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    excerpt: function(text, limit) {
      return text
        .split(/\s+/)
        .slice(0, limit)
        .join(' ')
    },
    plainText: function(HTML) {
      var input = HTML
      return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/>/g, ' ')
    },
    uppercase: function(string) {
      var splitStr = string.toLowerCase().split(' ')
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        if (
          splitStr[i] !== 'of' &&
          splitStr[i] !== 'the' &&
          splitStr[i] !== 'and'
        ) {
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
        }
      }
      // Directly return the joined string
      return splitStr.join(' ')
    },
    s3: function(path) {
      return appConfig.s3_endpoint + path
    },
  },
  data() {
    return {
      article: [],
      reports: [],
      relateds: [],
      notFoundState: false,
      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',
      /** skeleton and loading state */
      // loadOpacity: false,
      isLoading: true,
      pageName: 'legal-analysis-single',
      currentUrl: window.location.origin + window.location.pathname,
      /** FOR SEO AND META TAG PURPOSE */
      featuredImage: '',
      pageTitle: 'Loading...',
      pageMeta: [],
      origin: window.location.origin,
    }
  },
  async mounted() {
    const watchLang = queryString.parse(window.location.search).lang
    if (watchLang) {
      await this.getLegalAnalysis({ lang_relation: watchLang })
    } else {
      await this.getLegalAnalysis()
    }
    await this.getFullReport()

    const url = this.$route
    window.addEventListener('popstate', (e) => {
      history.pushState(
        { page: url.query.page },
        'page',
        `?page=${url.query.page === '0' ? '1' : url.query.page}${
          url.query.cat
            ? `&catID=${url.query.cat.split('_')[0]}&cat=${
                url.query.cat.split('_')[1]
              }`
            : ''
        }&ref=self`
      )
    })
  },
  methods: {
    getLegalAnalysis(param = {}) {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'legal-analysis',
        record_slug: this.$route.params.slug,
        lang: this.lang,
        simple: true,
      }
      /** params need to encoded from object to url params */
      params = this.generateParams(params, param)
      /** define endpoint */
      var endpoint = `klaster-by-member-relation?${params}`
      Axios.get(endpoint).then((response) => {
        const data = response.data.data[0]
        if (data) {
          this.article = data
          /** FOR SEO AND META TAG PURPOSE */
          this.pageTitle = data.title

          this.pageMeta = [
            {
              name: 'description',
              content: this.$options.filters
                .plainText(data.content)
                .slice(0, 160),
            },
            // facebook
            {
              property: 'og:type',
              content: 'article',
            },
            {
              property: 'og:title',
              content: data.title,
            },
            {
              property: 'og:description',
              content: this.$options.filters
                .plainText(data.content)
                .slice(0, 160),
            },
            {
              property: 'og:image',
              content: this.featuredImage,
            },
            {
              property: 'og:url',
              content: this.currentUrl,
            },
            {
              property: 'og:site_name',
              content: appConfig.title,
            },
            // twitter
            {
              name: 'twitter:title',
              content: data.title,
            },
            {
              name: 'twitter:image',
              content: this.featuredImage,
            },
            {
              name: 'twitter:description',
              content: this.$options.filters
                .plainText(data.content)
                .slice(0, 160),
            },
            {
              name: 'twitter:site',
              content: this.currentUrl,
            },
          ]
          /** GET RELATED */
          if (this.lang === 'id' && data.related) {
            this.getRelated(data.ID, {
              taxonomy: {
                tags_id: data.related[0].data,
              },
            })
          } else if (this.lang === 'en' && data.related) {
            this.getRelated(data.ID, {
              taxonomy: {
                tags_en: data.related[0].data,
              },
            })
          }
          this.isLoading = false
          this.openComment()
        } else {
          this.isLoading = false
          this.notFoundState = true
        }
      })
    },
    /**
     * Get related Articles
     */
    getRelated: function(excludeId, param = {}) {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'legal-analysis',
        attribute_show: false,
        lang: this.lang,
        record_exclude: excludeId,
        simple: true,
      }
      /** loop param then push to params */
      if (Object.keys(param).length > 0) {
        Object.keys(param).forEach((each) => {
          // attribute[tanggal_ditetapkan][]
          params[each] = param[each]
        })
      }
      /** params need to encoded from object to url params */
      let attr = ''
      params = Object.keys(params)
        .map(function(key) {
          if (key === 'taxonomy' && Object.keys(params).length > 0) {
            // first loop the 'params'
            Object.keys(params[key]).forEach((each1) => {
              attr += `taxonomy[${each1}]=${params[key][each1]}`
              attr += '&'
            })
            return attr.slice(0, -1)
          } else {
            return key + '=' + params[key]
          }
        })
        .join('&')
      /** token required for getting data from backend  */
      const getOptions = {
        headers: {
          Authorization: appConfig.default_token,
          'Access-Control-Allow-Origin': '*',
        },
      }
      /** define endpoint */
      var endpoint = `${appConfig.endpoint}/klaster-by-member-relation?${params}`
      Axios.get(endpoint, getOptions).then((response) => {
        const data = response.data.data
        if (data) {
          this.relateds = data
        }
      })
    },
    /**
     * Open Comment, this should be in Mixin!
     */
    openComment: function() {
      // momento js
      const momento = document.createElement('script')
      momento.setAttribute('src', 'https://commento.lexikan.id/js/commento.js')
      document.head.appendChild(momento)
    },
    /**
     * Get Full Report Files
     */
    getFullReport: function(param = {}) {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'report-files',
        attribute: {
          full_or_summary: 'full',
        },
        taxonomy_show: false,
        lang: this.lang,
        simple: true,
      }
      /** params need to encoded from object to url params */
      params = this.generateParams(params, param)
      /** token required for getting data from backend  */
      const getOptions = {
        headers: {
          Authorization: appConfig.default_token,
          'Access-Control-Allow-Origin': '*',
        },
      }
      /** define endpoint */
      var endpoint = `${appConfig.endpoint}/klaster-by-member-relation?${params}`
      Axios.get(endpoint, getOptions).then((response) => {
        const data = response.data.data[0]
        this.reports = data
        this.featuredImage = data.atribut.featured_image
          ? appConfig.s3_endpoint + data.atribut.featured_image.data[0].content
          : ''
      })
    },
    /**
     * Render category name
     */
    renderCategory: function(Obj, type = 'title') {
      if (this.lang === 'en') {
        if (Obj.length !== 0 && Obj.category_en.data[0]) {
          return Obj.category_en.data[0][type] + '/'
        } else {
          return ''
        }
      } else {
        if (Obj.length !== 0 && Obj.category.data[0]) {
          return Obj.category.data[0][type] + '/'
        } else {
          return ''
        }
      }
    },
    /**
     * Push 'TO' url
     */
    to: function(url) {
      this.$router.push({
        path: '/legal-analysis/' + url,
      })
    },
    /**
     * Download handler from backend
     */
    download: function(id) {
      // this.getFullReport()
      return appConfig.download_handler + id
    },
  },
}
</script>

<template>
  <div>
    <b-container v-if="notFoundState">
      <b-row :class="$style.errorHandler">
        <b-col cols="12">
          <p>{{ $t('analysis_no_data') }} </p>
          <a
            class="text-primary"
            pointer
            @click="$router.push({ name: 'legal-analysis' })"
            >{{ $t('back_page') }}</a
          >
        </b-col>
      </b-row>
    </b-container>
    <Skeleton
      v-if="isLoading && notFoundState === false"
      :type="pageName === 'default' ? 'default' : pageName"
    ></Skeleton>
    <Layout v-else-if="isLoading === false && notFoundState === false">
      <b-container :class="$style.containerMargin">
        <b-row>
          <b-col cols="12">
            <!-- Breadcrumb -->
            <Breadcrumb
              parent="legal-analysis"
              :paging="{
                category: {
                  text: this.$route.params.category,
                  url: `#${this.$route.params.catID}_${this.$route.params.category}`,
                },
                slug: {
                  text: this.$route.params.slug,
                  url: this.$route.params.slug,
                },
              }"
            ></Breadcrumb>
            <!-- end of Breadcrumb -->
          </b-col>
          <b-col cols="lg-8">
            <section :class="$style.single">
              <div :class="$style.singleHeader">
                <h1 :class="$style.singleHeaderTitle">{{
                  article.title | capitalize
                }}</h1>
                <span :class="$style.singleHeaderDate">
                  <span
                    v-if="
                      article.atribut.author &&
                        article.atribut.author.data.length !== 0
                    "
                  >
                    Penulis:
                    <span
                      v-for="(author, i) in article.atribut.author.data"
                      :key="i"
                      >{{ author.content }}
                    </span>
                    <span class="mx-2">|</span>
                  </span>
                  <i>{{ article.created_at_format }}</i>
                </span>
              </div>
              <div
                v-if="
                  article.atribut.disclaimer &&
                    article.atribut.disclaimer.data.length !== 0
                "
              >
                <b-alert variant="secondary" show dismissible>
                  <span style="font-size: .9em">{{
                    article.atribut.disclaimer.data[0].content
                  }}</span></b-alert
                >
              </div>
              <div
                v-html-safe="article.content"
                :class="$style.singleContent"
              ></div>
              <div :class="$style.singleFooter">
                <b-row class="mb-5">
                  <b-col cols="6">
                    <b-button
                      v-if="article.prev"
                      variant="dark"
                      class="py-2 px-3"
                      @click="
                        to(
                          article.prev.slug +
                            '/' +
                            renderCategory(article.taksonomi) +
                            /* eslint-disable */
                            renderCategory(
                              article.taksonomi,
                              'ktaksonomi_record_id'
                            )
                          /* eslint-enable */
                        )
                      "
                      >Previous Content</b-button
                    >
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <b-button
                      v-if="article.next"
                      variant="primary"
                      class="py-2 px-3"
                      @click="
                        to(
                          article.next.slug +
                            '/' +
                            renderCategory(article.taksonomi) +
                            /* eslint-disable */
                            renderCategory(
                              article.taksonomi,
                              'ktaksonomi_record_id'
                            )
                          /* eslint-enable */
                        )
                      "
                      >Next Content</b-button
                    >
                  </b-col>
                </b-row>

                <div class="socialShare my-5">
                  {{ $t('Share') }} :
                  <ShareNetwork
                    network="facebook"
                    :url="currentUrl"
                    :title="article.title"
                    :description="article.content | plainText | excerpt(25)"
                    hashtags="lexikan"
                  >
                    <img
                      src="@assets/icons/Icon_FB.png"
                      alt=""
                      class="social"
                    />
                  </ShareNetwork>
                  <ShareNetwork
                    network="twitter"
                    :url="
                      `${origin}/sharer.php?page=legal-analysis&slug=${article.slug}`
                    "
                    :title="article.title"
                    hashtags="lexikan"
                  >
                    <img
                      src="@assets/icons/Icon_Twitter.png"
                      alt=""
                      class="social"
                    />
                  </ShareNetwork>
                  <ShareNetwork
                    network="linkedin"
                    :title="article.title"
                    :url="currentUrl"
                  >
                    <img
                      src="@assets/icons/Icon_Linkedin.png"
                      alt=""
                      class="social"
                    />
                  </ShareNetwork>
                </div>
              </div>
            </section>
            <!-- Comment section -->
            <section id="comment">
              <div id="commento"></div>
            </section>
          </b-col>
          <b-col cols="lg-4" class="mt-3 pl-3 pl-lg-5">
            <PlainCard
              v-if="reports.atribut"
              :title="$t('Full Report')"
              :header-border="true"
            >
              <div class="px-2">
                <div>
                  <img
                    v-for="(img, index) in reports.atribut.featured_image.data"
                    :key="index"
                    :src="img.content | s3"
                    :alt="reports.title"
                    class="w-75 d-block"
                  />
                </div>
                <div v-if="reports.atribut">
                  <span class="d-block my-3">
                    <!-- eslint-disable -->
                    {{
                      $t(
                        'Please download full report file if you want to learn more about these topics.'
                      )
                    }}
                    <!-- eslint-enable -->
                  </span>
                  <a
                    v-if="reports.atribut.file && reports.atribut.file.data"
                    :href="download(reports.atribut.file.data[0].ID)"
                    class="bg-primary text-white px-3 py-2 my-2 d-flex align-items-center btn-block justify-content-center"
                  >
                    <img
                      src="@assets/icons/Icon_Download.png"
                      alt=""
                      :style="{ filter: 'brightness(5)', marginRight: '.5rem' }"
                      width="14"
                    />
                    {{ $t('Download') }}
                  </a>
                  <small
                    v-if="reports.atribut.download_counts.data.length !== 0"
                    >{{ $t('Downloads') }}:
                    {{ reports.atribut.download_counts.data[0].content }}</small
                  >
                </div>
              </div>
            </PlainCard>

            <PlainCard
              v-if="relateds.length !== 0"
              title="Related Contents"
              class="mt-5"
              :header-borderless="true"
            >
              <ul>
                <li v-for="(related, index) in relateds" :key="index">
                  <router-link
                    :to="
                      '/legal-analysis/' +
                        related.slug +
                        '/' +
                        renderCategory(related.taksonomi) +
                        /* eslint-disable */
                        renderCategory(
                          related.taksonomi,
                          'ktaksonomi_record_id'
                        )
                      /* eslint-enable */
                    "
                  >
                    {{ related.title }}</router-link
                  >
                </li>
              </ul>
            </PlainCard>
          </b-col>
        </b-row>
      </b-container>
    </Layout>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.containerMargin {
  margin: 2rem auto;
}
.errorHandler {
  display: flex;
  align-items: center;
  min-height: 50vh;
}
.single {
  font-family: $content-font-family !important;
  .singleHeader {
    margin-bottom: 2rem;
    .singleHeaderTitle {
      font-weight: $bold;
      color: $dark;
    }
    .singleHeaderDate {
      margin-top: 1rem;
      color: #8b8b8b;
    }
  }
  .singleContent {
    // font-weight: 500;
    margin: 1rem 0 2rem 0;
    text-align: justify;
    * {
      color: #8b8b8b;
    }
    // each image
    img {
      max-width: 100%;
    }
    // table styling for each table
    table {
      td {
        color: #8b8b8b;
        border: 2px solid $gray;
        span {
          color: #8b8b8b;
        }
      }
      tr {
        // style table header
        &:first-child {
          background: #f7f7f7;
          td {
            padding: 2rem 0.75rem;
            color: $primary;
          }
        }
      }
    }
  }
}
.active {
  a {
    color: $primary !important;
  }
}
</style>
